export default __webpack_public_path__ + "static/media/WSI_WHITE.4416b237.png";